import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '@/stores/useSessionStore';
import { useChatStore } from '@/stores/useChatStore';

/**
 * 组合 Hook：整合会话管理与聊天状态。
 */
export function useSessionManager() {
  const navigate = useNavigate();
  const createSession = useSessionStore((s) => s.createSession);
  const deleteSession = useSessionStore((s) => s.deleteSession);
  const currentSession = useSessionStore((s) => s.currentSession);
  const clearMessages = useChatStore((s) => s.clearMessages);

  /**
   * 创建新会话并自动切换。
   */
  const createAndSwitchSession = useCallback(async () => {
    clearMessages();
    const session = await createSession();
    if (session) {
      navigate('/chat');
    }
    return session;
  }, [createSession, clearMessages, navigate]);

  /**
   * 删除会话并导航。
   */
  const deleteSessionAndNavigate = useCallback(
    async (id: string) => {
      await deleteSession(id);
      if (currentSession?.session_id === id) {
        clearMessages();
        navigate('/chat');
      }
    },
    [deleteSession, currentSession, clearMessages, navigate]
  );

  return {
    createAndSwitchSession,
    deleteSessionAndNavigate,
    currentSession,
  };
}
